<template>
  <chart-container :title="title">
    <template v-slot:controls> </template>
    <div v-if="options.nodes.length > 0" :class="{ overlay: fullscreen }">
      <div class="d-flex justify-end mr-4 mt-1">
        <v-btn
          class="text-capitalize mb-1"
          width="20"
          height="20"
          @click="fullscreen = !fullscreen"
          outlined
          icon
        >
          <v-icon size="14">aspect_ratio</v-icon>
        </v-btn>
      </div>
      <network
        ref="network"
        :key="key"
        :nodes="options.nodes"
        :edges="options.edges"
        :options="computedOptions"
      ></network>
    </div>
    <v-row v-else>
      <v-col
        cols="12"
        :style="{ height: this.computedHeigth - 63 + 'px' }"
        class="body-1 text--secondary text-capitalize d-flex justify-center align-center my-8"
      >
        <div>No disponible</div>
      </v-col>
    </v-row>
  </chart-container>
</template>


<script>
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { splitIndexKey, getRandomString } from "@/commons/util.js";

export default {
  data() {
    return {
      key: getRandomString(),
      fullscreen: false,
    };
  },
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    this.setupListeners();
  },
  updated() {
    this.setupListeners();
  },
  methods: {
    setupListeners() {
      if (this.$refs.network) {
        const networkRef = this.$refs.network.network;
        networkRef.on("click", (params) => {
          let ids = params.nodes;
          if (ids.length > 0) {
            let { type, text } = splitIndexKey(ids[0]);
            if (type == "MENTION") {
              window.open("https://www.twitter.com/" + text.slice(1), "_blank");
            }
            if (type == "URL") {
              window.open(text, "_blank");
            }
          }
        });
        networkRef.on("hoverNode", (params) => {
          let { type } = splitIndexKey(params.node);
          if (type == "MENTION" || type == "URL") {
            networkRef.canvas.body.container.style.cursor = "pointer";
          }
        });
        networkRef.on("blurNode", () => {
          networkRef.canvas.body.container.style.cursor = "default";
        });
        window.onresize = () => {
          if (typeof networkRef !== "undefined" && networkRef) {
            networkRef.fit();
          }
        };
      }
    },
  },
  computed: {
    computedOptions() {
      const h = window.innerHeight * 0.9;
      const localOptions = {
        height: this.fullscreen
          ? h.toString() + "px"
          : this.computedHeigth + "px",
        width: "100%",
        nodes: {
          borderWidth: 1,
        },
        edges: {
          color: "lightgray",
        },
      };
      return _merge({}, localOptions, this.options.plotOptions);
    },
    computedHeigth() {
      switch (this.height) {
        case 185:
          return 173;
        case 200:
          return 188;
        case 300:
          return 289.2;
        case 340:
          return 328;
        default:
          return (this.height || 204) * 15;
      }
    },
  },
  watch: {
    options: function () {
      if (this.$refs.network && this.$refs.network.network) {
        this.$refs.network.network.fit();
      }
    },
    fullscreen: function () {
      this.key = getRandomString();
    },
  },
};
</script>
<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 70px;
  background: rgba(255, 255, 255, 1);
  z-index: 10;
}
</style>